import { render, staticRenderFns } from "./ResourceDataComponent.vue?vue&type=template&id=4cfb0221"
import script from "./ResourceDataComponent.vue?vue&type=script&lang=js"
export * from "./ResourceDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports